<style lang="scss">
</style>

<template>
    <div class="search-wrap">
        <!-- <aside class='search-btn'>
            <ButtonGroup>
                <Button  v-for="(item,index) in btnsearch" :key="index" :type="formData.EQ_status===item.value?'primary':'default'" @click="handleBtn('EQ_status',item.value)">{{item.label}}</Button>
            </ButtonGroup>
        </aside> -->
        <article class="search-main clearfix">
            <div class="pull-left">
                <!-- <Button type="ghost" @click="handleModal('add')">添加</Button>
                <Button type="ghost" @click="handleModal('upload')">导入</Button> -->
                <Dropdown trigger="click">
                    <Button>
                        更多操作<Icon type="md-arrow-dropdown" />
                    </Button>
                    <DropdownMenu slot="list">
                        <DropdownItem class="splitline" @click.native="handleModal('operate')">批量处理</DropdownItem>
                        <DropdownItem @click.native="handleModal('cancel')">批量取消</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </div>

            <div class="pull-right">
                <Form :label-width="90" inline>
                    <FormItem label='ERPSKU'>
                        <Input clearable v-model.trim="formData.CN_erpSku"/>
                    </FormItem>
                    <FormItem label='Seller SKU'>
                        <Input clearable v-model.trim="formData.CN_sellerSku"/>
                    </FormItem>
                    <FormItem label='项目'>
                        <Select clearable v-model="formData.EQ_lineId" filterable>
                            <Option v-for="item in getNewProductList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem :label-width="1">
                        <Button type="primary" @click="update" icon="ios-search">搜索</Button>
                        <Button @click="reset" icon='md-refresh'>重置</Button>
                        <Button type="text" @click="isOpen=!isOpen">更多搜索<Icon type="ios-arrow-down" class="margin-left-5"></Icon></Button>
                    </FormItem>
                </Form>
            </div>
        </article>
        <transition name='slide-both'>
            <Form class="search-other" :label-width="80" inline v-show="isOpen">
                <FormItem label='店铺'>
                    <Select clearable v-model="formData.EQ_accountId" filterable>
                        <Option v-for="item in getNewAccountIdList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                </FormItem>
                <FormItem label='锁定仓库'>
                    <Select clearable v-model="formData.EQ_orgWarehouseId" filterable>
                        <Option v-for="item in getChangeWarehouse" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                </FormItem>
                 <FormItem label='起至日期'>
                    <DatePicker clearable v-model="formData.BT_beginDate" type="daterange"  placeholder="Select date"></DatePicker>
                </FormItem>
                <FormItem label='处理结果'>
                    <Select clearable v-model="formData.EQ_dealStatus" filterable>
                        <Option v-for="item in dealStatus" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                </FormItem>
            </Form>
        </transition>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {

    data() {
        return {
            isOpen: false,

            dealStatus: [{
                value: 'DRAFT',
                label: "待处理"
            }, {
                value: 'ACTIVATE',
                label: "已处理"
            }, {
                value: 'CANCEL',
                label: "异常"
            }, {
                value: 'APPLY',
                label: "不限"
            },],
            formData: {
                NE_errorStatus: 0,
                CN_erpSku: '',
                CN_sellerSku: '',
                EQ_accountId: '',
                EQ_lineId: '',
                EQ_orgWarehouseId: '',
                BT_beginDate: '',
                EQ_status: 'ACTIVATE',
                EQ_dealStatus: '',
            },
        };
    },
    mounted() {
        this.update();
    },
    computed: {
        // ...mapState('boss',['products', 'accounts']),
        ...mapGetters('boss', ['warehouses']),
        ...mapGetters('diction',['getNewProductList','getNewAccountIdList']),
        getChangeWarehouse(){
            return this.warehouses.map(item=>{
                return {
                    value:item.id,
                    label:item.title +' ('+ item.code +')' 
                }
            })
        },
        propsData(){
            return [
                {label:'ERPSKU',key:'CN_erpSku'},
                {label:'Seller SKU',key:'CN_sellerSku'},
                {label:this.$t('global.common.line',{defaultValue:'项目'}),key:'EQ_lineId',tag:'Select',value:this.getNewProductList},
                {label:this.$t('global.common.channel',{defaultValue:'店铺'}),key:'EQ_accountId',tag:'Select',value:this.getNewAccountIdList},
                {label:'锁定仓库',key:'EQ_orgWarehouseId',tag:'Select',value:this.getChangeWarehouse},
                {label:'起至日期',key:'BT_beginDate'},
                {label:'处理结果',key:'EQ_dealStatus',tag:'Select',value:this.dealStatus},
            ]
        },
    },
    methods: {
        handleModal(type, id) {
            this.$parent.handleOperates(id, type);
        },
        handleBtn(key, val) {
            this.$set(this.formData, key, val);
            this.update();
        },
        update() {
            const formdata = { ...this.formData }, beginDate = formdata.BT_beginDate;
            if (beginDate) {
                formdata.BT_beginDate = beginDate[0] ? this.handleDateFormat(beginDate[0], 'yyyy-mm-dd') + ' ~ ' + this.handleDateFormat(beginDate[1], 'yyyy-mm-dd') : '';
            }
            this.$emit('on-update', { search: formdata, page: 1 });
        },
        reset() {
            this.formData = {
                NE_errorStatus: 0,
                CN_erpSku: '',
                CN_sellerSku: '',
                EQ_accountId: '',
                EQ_lineId: '',
                EQ_orgWarehouseId: '',
                BT_beginDate: '',
                EQ_status: 'ACTIVATE',
                EQ_dealStatus: '',
            };
            this.$emit('on-update', {
                search: {
                    ...this.formData
                },
                page: 1
            });
        },
    },
};
</script>
